import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import util from "./js/utils"
import "./js/common.js";
import "./css/common.css";
import "./css/page.css";
import xmlog from "./js/log";// eslint-disable-line
// 导入图片预加载方法以及图片列表
import { imgsPreloader } from './js/imgPreloader';
import imgPreloaderList from './js/imgPreloaderList';
imgsPreloader(imgPreloaderList);
Vue.config.productionTip = false;
Vue.prototype.$util = util;
Vue.prototype.$xmlog = xmlog;
Vue.prototype.$bus = new Vue()


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

